import * as actionTypes from './action-types'
import * as mutationTypes from './mutation-types'
import { getLocation } from '@/utils/io/geolocation'
import { getCircuit, patchCircuit, postCircuit } from '@/utils/api/agency/circuits'
import { ACCOUNT_RIGHT_CREATE_MISSION, ACCOUNT_RIGHT_EDIT_MISSION } from '@/consts/rights'
import { postAgencyEvent, postAgencyEventPti } from '@/utils/api/event'
import { USER_AGENCY_FETCH_SITE_RONDES } from '@/store/modules/user/agency/action-types'

export default {
  [actionTypes.SERVICE_POST]: async ({ commit, dispatch, rootGetters }, { detail, checkpoint, ...oService }) => {
    const location = await getLocation()
    const req = {
      service: oService,
      event: {
        location,
        checkpoint,
        eventMessages: []
      }
    }
    if (detail) {
      req.event.eventMessages.push(detail)
    }
    const { service } = rootGetters['user/isGranted']([oService.id
      ? ACCOUNT_RIGHT_EDIT_MISSION
      : ACCOUNT_RIGHT_CREATE_MISSION
    ])
      ? await postCircuit(req)
      : await patchCircuit(req)
    commit(mutationTypes.SERVICE_SET_ACTIVE, service)
    dispatch('user/agency/' + USER_AGENCY_FETCH_SITE_RONDES, null, { root: true })
  },
  [actionTypes.SERVICE_REFRESH]: async ({ state, commit }) => {
    const { service } = await getCircuit(state.active.reference)
    commit(mutationTypes.SERVICE_SET_ACTIVE, service)
  },
  /******************************
   **** Gestion des tournées ****
   * TODO Refactor ? Traiter directement dans PUT_CIRCUIT... If isCircuit && id !== state.active.id :tada:
   ******************************/
  [actionTypes.SERVICE_PUT_CIRCUIT_SERVICE]: async ({ state, commit, rootGetters }, { detail, agent, ...oService }) => {
    const { active = {} } = state
    const req = {
      service: {
        ...oService,
        circuit: { id: active.id }
      },
      event: {
        location: await getLocation(),
        eventMessages: []
      }
    }
    if (detail) {
      req.event.eventMessages.push(detail)
    }
    const { service, event } = rootGetters['user/isGranted']([oService.id
      ? ACCOUNT_RIGHT_EDIT_MISSION
      : ACCOUNT_RIGHT_CREATE_MISSION
    ])
      ? await postCircuit(req)
      : await patchCircuit(req)
    const services = [...(active.services || [])]
    const iService = services.findIndex((s) => s.id === service.id)
    if (iService === -1) {
      services.push(service)
    } else {
      services.splice(iService, 1, service)
    }
    commit(mutationTypes.SERVICE_SET_ACTIVE, {
      ...active,
      services
    })
    commit(mutationTypes.SERVICE_SET_EVENT, { target: service, eventData: event })
  },
  [actionTypes.SERVICE_POST_EVENT]: async ({ state, commit, getters }, _event) => {
    const location = _event.location
      ? _event.location
      : await getLocation()
    const service = getters.serviceActif || state.active
    const { event } = await postAgencyEvent(
      {
        site: service.site,
        ..._event,
        service: service.id,
        location
      }
    )
    commit(mutationTypes.SERVICE_SET_EVENT, { target: service, event: _event, eventData: event })
    return event
  },
  [actionTypes.SERVICE_POST_EVENT_PTI]: async ({ state, commit, getters }, _event) => {
    const location = _event.location
      ? _event.location
      : await getLocation()
    const service = getters.serviceActif || state.active
    const { event } = await postAgencyEventPti({
      ..._event,
      service: service.id,
      location
    })
    commit(mutationTypes.SERVICE_SET_EVENT, { target: service, event: _event, eventData: event })
    return event
  }
}
